<ng-container *ngIf="step === 'form'">
  <div mat-dialog-title>
    <su-headline h="h3" skin="primary">{{
      'user.request.permissions.assignment.dialog.title' | translate
    }}</su-headline>
  </div>

  <div mat-dialog-content>
    <form [formGroup]="form">
      <formly-form
        [form]="form"
        [fields]="formFields"
        [model]="formModel"></formly-form>
    </form>
  </div>
  <div mat-dialog-actions>
    <su-button
      skin="secondary"
      [label]="'shared.cancel' | translate"
      mat-dialog-close></su-button>

    <su-button
      skin="primary"
      [label]="'shared.save' | translate"
      (onClick)="goToSummary()"></su-button>
  </div>
</ng-container>

<ng-container *ngIf="step === 'summary'">
  <div mat-dialog-title>
    <su-headline h="h3" skin="primary">{{
      'user.request.summary.title_permission' | translate
    }}</su-headline>
  </div>

  <div mat-dialog-content>
    <p class="confirm-value">
      {{ 'user.request.summary.p__info_summary' | translate }}
    </p>

    <div class="confirm-container">
      <div>
        <div class="confirm-label">
          <span>
            {{ 'user.request.summary.label__requestType' | translate }}:
          </span>
        </div>
        <div>
          <span class="confirm-value" *ngIf="data.isRequestForOwnUser">
            {{ 'user.request.permissions.own_user' | translate }}
          </span>
          <span class="confirm-value" *ngIf="!data.isRequestForOwnUser">
            {{ 'user.request.permissions.external_user' | translate }}
          </span>
        </div>
      </div>

      <div>
        <div class="confirm-label">
          <span> {{ 'user.request.summary.label__email' | translate }}: </span>
        </div>
        <div>
          <span class="confirm-value">{{ data.employee?.email }}</span>
        </div>
      </div>

      <div>
        <div class="confirm-label">
          <span>
            {{ 'user.request.summary.label__requestedRoles' | translate }}:
          </span>
        </div>
        <div>
          <ul *ngIf="selectedRoles.length > 0">
            <li class="confirm-value" *ngFor="let item of selectedRoles">
              {{ item.description }}
            </li>
          </ul>
          <span class="confirm-value" *ngIf="selectedRoles.length === 0">
            --
          </span>
        </div>
      </div>

      <div>
        <div class="confirm-label">
          <span>
            {{ 'user.request.summary.label__removedRoles' | translate }}:
          </span>
        </div>
        <div>
          <span class="confirm-value">--</span>
        </div>
      </div>

      <div *ngIf="!data.isTelekomEmployee">
        <div class="confirm-label">
          <span>
            {{
              'user.request.permissions.assignment.dialog.label__validFrom'
                | translate
            }}:
          </span>
        </div>
        <div>
          <span class="confirm-value">{{
            validFrom | date: 'dd.MM.yyyy'
          }}</span>
        </div>
      </div>

      <div *ngIf="!data.isTelekomEmployee">
        <div class="confirm-label">
          <span>
            {{
              'user.request.permissions.assignment.dialog.label__validUntil'
                | translate
            }}:
          </span>
        </div>
        <div>
          <span class="confirm-value">{{
            validUntil | date: 'dd.MM.yyyy'
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="confirm-buttons">
      <su-button
        [skin]="'primary'"
        [icon]="'arrow-left'"
        [label]="'ticket.create.confirm.button__back_to_edit' | translate"
        [disabled]="isLoading"
        (onClick)="backToEdit()">
      </su-button>
      <su-button
        [skin]="'accent'"
        [icon]="'paper-plane'"
        [label]="'ticket.create.confirm.button__send' | translate"
        [disabled]="isLoading"
        (onClick)="submitRequest()">
      </su-button>
    </div>
  </div>
</ng-container>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
